import { POLLING_INTERVAL } from "../constante/cache";
import { useAppSelector } from "../redux/store";

export default function useGetPollingInterval() {
    const modalOpened = useAppSelector(state => state.appState.modalsOpened);
    return modalOpened.length > 0 ? 0 : POLLING_INTERVAL;
}